module.exports = __webpack_public_path__ + "img/avatar-7.b940ea8a.jpg";